/* eslint-disable */
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
// If you need to update this file, make changes in the Core application
// then run `import:api` in your terminal from the root of this project.
import { AxiosPromise } from 'axios';

import { baseClientConstructorProps } from 'app/api/apiClient/config';

import { BaseClient, BaseClientConstructorProps, QueryParams, SendRequestPayload } from '../baseClient';
import { 
  CorePayeeInvoicesSearchInvoicesAndCreditNotesParams,
  CorePayeeInvoicesQpAvailableParams,
  CorePayeeInvoicesGetInvoiceStatusesParams,
  UpdateInvoiceRequest2,
  SearchInvoicesAndCreditNotesResponse,
  InvoiceResponse,
  QpAvailableResponse,
  InvoiceStatusWithCountResponse,
  DateTypesResponse
 } from '../types';

  //  CorePayeeInvoicesClient
class CorePayeeInvoicesClient extends BaseClient {
    constructor(props: BaseClientConstructorProps) {
        super(props);
    }

    readonly searchInvoicesAndCreditNotes = (queryParams: CorePayeeInvoicesSearchInvoicesAndCreditNotesParams): AxiosPromise<SearchInvoicesAndCreditNotesResponse> => {
        let url_ = "/api/v1/core/payee/invoices_and_credit_notes";

        const qParams = { ...queryParams };
        const hasExportReport = "exportReport" in qParams && qParams.exportReport;
        if (hasExportReport) {
            if ("page" in qParams) {
                delete qParams.page;
            }
            if ("pageSize" in qParams) {
                delete qParams.pageSize;
            }
        }

        const sendRequestPayload: SendRequestPayload = {
            responseType: hasExportReport ? "blob" : undefined,
            queryParams: qParams as unknown as QueryParams,
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly getInvoice = (id: string): AxiosPromise<InvoiceResponse> => {
        let url_ = "/api/v1/core/payee/invoices/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));

        const sendRequestPayload: SendRequestPayload = {
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly updateInvoice = (id: string, payload: UpdateInvoiceRequest2): AxiosPromise<InvoiceResponse> => {
        let url_ = "/api/v1/core/payee/invoices/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));

        const sendRequestPayload: SendRequestPayload = {
            data: payload,
            method: "PUT",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly qpAvailable = (queryParams: CorePayeeInvoicesQpAvailableParams): AxiosPromise<QpAvailableResponse> => {
        let url_ = "/api/v1/core/payee/invoices/total_qp_available";

        const qParams = { ...queryParams };
        const hasExportReport = "exportReport" in qParams && qParams.exportReport;
        if (hasExportReport) {
            if ("page" in qParams) {
                delete qParams.page;
            }
            if ("pageSize" in qParams) {
                delete qParams.pageSize;
            }
        }

        const sendRequestPayload: SendRequestPayload = {
            responseType: hasExportReport ? "blob" : undefined,
            queryParams: qParams as unknown as QueryParams,
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly getInvoiceStatuses = (queryParams: CorePayeeInvoicesGetInvoiceStatusesParams): AxiosPromise<InvoiceStatusWithCountResponse> => {
        let url_ = "/api/v1/core/payee/invoices/statuses";

        const qParams = { ...queryParams };
        const hasExportReport = "exportReport" in qParams && qParams.exportReport;
        if (hasExportReport) {
            if ("page" in qParams) {
                delete qParams.page;
            }
            if ("pageSize" in qParams) {
                delete qParams.pageSize;
            }
        }

        const sendRequestPayload: SendRequestPayload = {
            responseType: hasExportReport ? "blob" : undefined,
            queryParams: qParams as unknown as QueryParams,
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly getDateTypes = (): AxiosPromise<DateTypesResponse> => {
        let url_ = "/api/v1/core/payee/invoices/date_types";

        const sendRequestPayload: SendRequestPayload = {
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly getDateTypes2 = (): AxiosPromise<DateTypesResponse> => {
        let url_ = "/api/v1/core/payee/invoices_and_credit_notes/date_types";

        const sendRequestPayload: SendRequestPayload = {
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }
}
// CorePayeeInvoicesClient
  
export const corePayeeInvoicesClient = new CorePayeeInvoicesClient(baseClientConstructorProps);
